import { Tooltip } from '@toggle/design-system';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './AddWatchlistTriggerButton.styles';

export interface AddWatchlistTriggerButtonProps {
  isInWatchlist: boolean;
}

export const AddWatchlistTriggerButton = forwardRef<
  HTMLDivElement,
  AddWatchlistTriggerButtonProps
>(({ isInWatchlist, ...rest }, ref) => {
  const { t } = useTranslation('common');
  return (
    <div ref={ref}>
      <Tooltip
        label={
          isInWatchlist
            ? t('common:components.watchlistBtn.watching')
            : t('common:components.watchlistBtn.addToWatchlistLabel')
        }
        isTouchDevice={false}
        inPortal
      >
        <S.AddWatchlistButton
          $isInWatchlist={isInWatchlist}
          size="xsmall"
          iconName={isInWatchlist ? 'Checkmark' : 'Add'}
          variant="empty"
          {...rest}
        />
      </Tooltip>
    </div>
  );
});
